module.exports = __webpack_public_path__ + "img/coin2.f76e94c6.png";